module.exports = __webpack_public_path__ + "img/home-bg-m.68b842b0.png";